// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li.previous.disabled, li.next.disabled {\n  cursor: not-allowed;\n\n  a {\n    opacity: 0.65;\n    pointer-events: none;\n  }\n}", ""]);
// Exports
module.exports = exports;
